var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.137 8.168c.328 1.148.328 3.61.328 3.61s0 2.433-.328 3.609a1.824 1.824 0 0 1-1.313 1.312C16.648 17 12 17 12 17s-4.676 0-5.852-.3a1.824 1.824 0 0 1-1.312-1.313c-.328-1.176-.328-3.61-.328-3.61s0-2.46.328-3.609a1.86 1.86 0 0 1 1.312-1.34C7.324 6.5 12 6.5 12 6.5s4.648 0 5.824.328a1.86 1.86 0 0 1 1.313 1.34Zm-8.668 5.824 3.883-2.215-3.883-2.214v4.43Z"
  })));
};

export default SvgYoutube;